export default __webpack_public_path__ + "static/media/plaster-crutch-blue.741d08a3.svg";